import { render, staticRenderFns } from "./collectionModal.vue?vue&type=template&id=964b0fee&scoped=true"
import script from "./collectionModal.vue?vue&type=script&lang=js"
export * from "./collectionModal.vue?vue&type=script&lang=js"
import style0 from "./collectionModal.vue?vue&type=style&index=0&id=964b0fee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964b0fee",
  null
  
)

export default component.exports